import { Button, Card, Col, Row, Typography } from "antd";
import React, {useState } from "react";
import PurchasePointModal from "./PurchasePointModal";
import SuccessPage from "./SuccessPage";
import FailedPage from "./FailedPage";
import LoadingPage from "./LoadingPage";
import { PlusCircleOutlined } from "@ant-design/icons";
const MyBalance = ({walletSummary, refreshBalance}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [isLoadingModalOpen, setIsLoadingModalOpen] = useState(false);
  const [rechargedAmount, setRechargedAmount] = useState(0);
  const { Text } = Typography;

  const availableBalance = Number(walletSummary?.availableBalance || 0);
  
  const openPurchaseModal = () => {
    setIsModalOpen(true);
  };

  const closePurchaseModal = () => {
    setIsModalOpen(false);
  };

  const openSuccessModal = (amount) => {
    setRechargedAmount(Number(amount || 0));
    setIsSuccessModalOpen(true);
  };

  const closeSuccessModal = () => {
    setIsSuccessModalOpen(false);
  };

  const openFailedModal = () => {
    setIsFailedModalOpen(true);
  };

  const closeFailedModal = () => {
    setIsFailedModalOpen(false);
  };
  
  const openLoadingModal = () => {
    setIsLoadingModalOpen(true)
  }

  const closeLoadingModal = () => {
    setIsLoadingModalOpen(false);
  }

  return (
    <>
      <div>
  <Card bodyStyle={{ padding: "28px 36px" }} style={{ borderRadius: 14, border: "0.5px solid #ebebeb" }}>
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

    <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
      <div style={{ width: 54, height: 54, borderRadius: 12, background: "#EAF3DE", display: "flex", alignItems: "center", justifyContent: "center" }}>
<svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="2" y="7" width="20" height="14" rx="2.5" stroke="#3B6D11" stroke-width="1.5"/>
  <path d="M2 11h20" stroke="#3B6D11" stroke-width="1.5"/>
  <path d="M6 4h12" stroke="#3B6D11" stroke-width="1.5" stroke-linecap="round"/>
  <circle cx="16.5" cy="15.5" r="1.5" fill="#639922"/>
</svg>
      </div>
      <div>
        <div style={{ fontSize: 11, fontWeight: 500, letterSpacing: "0.09em", textTransform: "uppercase", color: "#8c8c8c", marginBottom: 6 }}>
          Credit Balance
        </div>
        <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
          <span style={{ fontSize: 16, color: "#8c8c8c" }}>INR</span>
          <span style={{ fontSize: 36, fontWeight: 500, color: "#1a1a1a", letterSpacing: "-0.03em", lineHeight: 1 }}>
            {availableBalance.toLocaleString("en-IN")}
          </span>
        </div>
        {/* <div style={{ display: "inline-flex", alignItems: "center", gap: 5, marginTop: 8, background: "#EAF3DE", borderRadius: 20, padding: "3px 12px", fontSize: 11, color: "#27500A", fontWeight: 500 }}>
          <span style={{ width: 5, height: 5, borderRadius: "50%", background: "#639922", display: "inline-block" }} />
          Active wallet
        </div> */}
      </div>
    </div>

    <Button
      type="primary"
      style={{ background: "#1a3353", borderColor: "#1a3353", borderRadius: 10, fontWeight: 500, height: 46, fontSize: 14, paddingInline: 30 }}
      onClick={openPurchaseModal}
    >
      + Add Funds
    </Button>

  </div>
  <div
    style={{
      marginTop: 18,
      paddingTop: 16,
      borderTop: "1px solid #edf2f7",
    }}
  >
    <div
      style={{
        fontSize: 13,
        fontWeight: 700,
        color: "#1a3353",
        marginBottom: 6,
      }}
    >
      Note:
    </div>
    <div
      style={{
        fontSize: 13,
        lineHeight: 1.7,
        color: "#4b5563",
        maxWidth: 780,
      }}
    >
      Wallet Available Amount can only be used to unlock the Enquiries and it cannot be claimed / encash.
    </div>
  </div>
</Card>
      </div>
      {isModalOpen && (
        <PurchasePointModal
          isPurchasePointModalOpen={isModalOpen}
          onClose={closePurchaseModal}
          openSuccessModal={openSuccessModal}
          openFailedModal={openFailedModal}
          openLoadingModal={openLoadingModal}
          closeLoadingModal={closeLoadingModal}
          refreshBalance={refreshBalance}
          walletSummary={walletSummary}
        />
      )}

      {isSuccessModalOpen && (
        <SuccessPage
          isSuccessModalOpen={isSuccessModalOpen}
          onCloseSuccessModal={closeSuccessModal}
          planName="Wallet"
          amount={`INR ${rechargedAmount.toLocaleString("en-IN")}`}
        />
      )}

      {isFailedModalOpen && (
        <FailedPage
          isFailedModalOpen={isFailedModalOpen}
          onCloseFailedModal={closeFailedModal}
          isPurchasePointModalOpen={isModalOpen}
        />
      )}

      {
        isLoadingModalOpen && (
          <LoadingPage
          isLoadingModalOpen={isLoadingModalOpen}
          onCloseLoadingModal={closeLoadingModal}
        />
        )
      }

    </>
  );
};

export default MyBalance;
